import styled from "styled-components";

const EditorContainer = styled.div`
  border: solid 1px var(--default-dark-gray);
  width: 100%;
`;

export { EditorContainer };
